// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountValue } from './account-value';
import { Admin } from './admin';
import { AssetClass } from './asset-class';
import { Contact } from './contact';
import { Contribution } from './contribution';
import { Counterparty } from './counterparty';
import { CurrencyRate } from './currency-rate';
import { CurrencyType } from './currency-type';
import { SecurityAsset } from './security-asset';
import { SubEntry } from './sub-entry';
import { iTask } from './i-task';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Asset extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  assetId!: number;
  accountId?: number;
  adjudicatedArrears?: number;
  adminId!: number;
  arrearsPeriod?: string;
  assetClassId?: number;
  assetDate?: Date;
  assetQuantity?: number;
  assetTax!: number;
  assetValue!: number;
  assetValue1!: number;
  businessRate?: number;
  completionDate?: Date;
  contributionId?: number;
  counterpartyId?: number;
  createdBy!: string;
  createdDate!: Date;
  currencyRateId?: number;
  currencyTypeId!: number;
  deedsLocation?: string;
  description?: string;
  entryId?: number;
  ervhigh!: number;
  ervlow!: number;
  fxrevalueOnChange!: boolean;
  fxtotalRealisationCosts!: number;
  fxtotalRealised!: number;
  fxvalue!: number;
  isAvailableForRealisation!: boolean;
  isCommercial?: boolean;
  isDisclaimed!: boolean;
  isFreehold?: boolean;
  isFullyRealised!: boolean;
  isInputTax?: boolean;
  isMainResidence?: boolean;
  isRataasset!: boolean;
  landlord?: string;
  leaseDuration?: string;
  managingAgentContactId?: number;
  memo?: string;
  parentAssetAssetId?: number;
  purchasedFor!: number;
  rataerv!: number;
  ratepayer?: string;
  rates?: number;
  ratingsAuthority?: string;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  rent?: number;
  rentArrears?: number;
  rentReviewDate?: Date;
  rentReviewNoticeDate?: Date;
  securityDetails?: string;
  subTenants?: string;
  surety?: string;
  taskId?: number;
  tenancy?: string;
  tenancyExpiryDate?: Date;
  timeIsOfEssence?: boolean;
  titleDetails?: string;
  totalRealisationCosts!: number;
  totalRealised!: number;
  totalWrittenOnOff!: number;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  usage?: string;
  account!: Account;
  accountValues!: AccountValue[];
  admin!: Admin;
  assetClass!: AssetClass;
  contribution!: Contribution;
  counterparty!: Counterparty;
  currencyRate!: CurrencyRate;
  currencyType!: CurrencyType;
  inverseParentAssetAsset!: Asset[];
  managingAgentContact!: Contact;
  parentAssetAsset!: Asset;
  securityAssets!: SecurityAsset[];
  subEntries!: SubEntry[];
  task!: iTask;
}

